/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import React from 'react';
import { format, isToday, isYesterday } from 'date-fns';

import MessageStatuses, { StatusesEnum } from './MessageStatuses';
import { Sender } from '../../ChatBodyNew';

import {
    StyledMessageAvatar,
    StyledMessageBubble,
    StyledMessageItem,
    StyledMessageItemDate,
    StyledMessageTime,
} from './MessageItem.styled';

import LogoExample from 'assets/icons/LogoExample.png';

interface Props {
    showItemDate?: boolean;
    status?: StatusesEnum;
    message?: string;
    sender: Sender;
    time?: string;
    avatar?: any;
    author: string;
}

export default function MessageItem(props: Props) {
    const {
        status = StatusesEnum.DELIVERED,
        sender = Sender.OTHER,
        message = '',
        avatar,
        time,
        author,
    } = props;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const messagesDate = isToday(new Date(time))
        ? 'TODAY'
        : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          isYesterday(new Date(time))
          ? 'YESTERDAY'
          : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            format(new Date(time), 'MMM d y');

    const handleTimeValue = (timeValue: string | undefined) => {
        if (timeValue) {
            return format(new Date(timeValue), 'HH:mm');
        }
        return '';
    };

    const formattedMessage = `${author}:\n${message}`;

    return (
        <>
            {props.showItemDate && <StyledMessageItemDate>{messagesDate}</StyledMessageItemDate>}
            <StyledMessageItem sender={sender}>
                {avatar ? (
                    <StyledMessageAvatar src={avatar.default} alt="" />
                ) : sender !== Sender.ME ? (
                    <StyledMessageAvatar src={LogoExample} alt="" />
                ) : (
                    <MessageStatuses status={status} />
                )}

                <StyledMessageBubble sender={sender}>
                    {formattedMessage.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </StyledMessageBubble>
                <StyledMessageTime>{handleTimeValue(time)}</StyledMessageTime>
            </StyledMessageItem>
        </>
    );
}
